// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Modern Header Styling */
.header-container {
    width: 100%;
    height: 60px;
    background: #458acf;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    color: #ecf0f1;
  }
  
  .header-left h2 {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .header-right {
    display: flex;
    align-items: center;
  }
  
  .header-user-info {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  
  .user-name {
    margin-left: 10px;
    font-size: 1.1rem;
    font-weight: 500;
  }
  
  .header-notifications,
  .header-logout {
    display: flex;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    transition: color 0.3s ease;
  }
  
  .header-icon {
    font-size: 1.5rem;
  }
  
  .logout-text {
    margin-left: 10px;
    font-size: 1.1rem;
  }
  
  .header-notifications:hover,
  .header-logout:hover {
    color: #00bcd4;
  }
  
  @media (max-width: 768px) {
    .header-left h2 {
      font-size: 1.2rem;
    }
    .user-name,
    .logout-text {
      font-size: 1rem;
    }
  }
  
  @media (max-width: 576px) {
    .header-container {
      padding: 0 10px;
    }
    .header-left h2 {
      font-size: 1rem;
    }
    .user-name,
    .logout-text {
      font-size: 0.9rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/dashboard/styles/header.css"],"names":[],"mappings":";AACA,0BAA0B;AAC1B;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,wCAAwC;IACxC,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE;MACE,iBAAiB;IACnB;IACA;;MAEE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;;MAEE,iBAAiB;IACnB;EACF","sourcesContent":["\n/* Modern Header Styling */\n.header-container {\n    width: 100%;\n    height: 60px;\n    background: #458acf;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    color: #ecf0f1;\n  }\n  \n  .header-left h2 {\n    font-size: 1.5rem;\n    font-weight: bold;\n  }\n  \n  .header-right {\n    display: flex;\n    align-items: center;\n  }\n  \n  .header-user-info {\n    display: flex;\n    align-items: center;\n    margin-right: 20px;\n  }\n  \n  .user-name {\n    margin-left: 10px;\n    font-size: 1.1rem;\n    font-weight: 500;\n  }\n  \n  .header-notifications,\n  .header-logout {\n    display: flex;\n    align-items: center;\n    margin-left: 20px;\n    cursor: pointer;\n    transition: color 0.3s ease;\n  }\n  \n  .header-icon {\n    font-size: 1.5rem;\n  }\n  \n  .logout-text {\n    margin-left: 10px;\n    font-size: 1.1rem;\n  }\n  \n  .header-notifications:hover,\n  .header-logout:hover {\n    color: #00bcd4;\n  }\n  \n  @media (max-width: 768px) {\n    .header-left h2 {\n      font-size: 1.2rem;\n    }\n    .user-name,\n    .logout-text {\n      font-size: 1rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .header-container {\n      padding: 0 10px;\n    }\n    .header-left h2 {\n      font-size: 1rem;\n    }\n    .user-name,\n    .logout-text {\n      font-size: 0.9rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
